<template>
  <div class="kiaf-person-center-wrapper">
    <kc-popover placement="bottom-end" v-model="popoverShow" v-model:visible="popoverShow" :width="downloadShow ? '15rem' : '12.4rem'" popper-class="kiaf-person-center kiaf-person-center-popper">
      <div slot="reference" class="kiaf-person-center" v-if="!isVue3">
        <div class="myself" @click="showPersonCenter">
          <div @click="checkPersonal" class="avatar"></div>
          <span v-if="mode === 'photo'" class="user-name">{{
            userinfo.username
          }}</span>
          <span
                  @click="checkPersonal"
                  v-else-if="customize.avatarMode && userinfo.username"
                  class="user-name"
          >{{ avatarTitle() }}</span
          >
        </div>
      </div>
      <template #reference v-if="isVue3">
        <div class="kiaf-person-center">
          <div class="myself" @click="showPersonCenter">
            <div @click="checkPersonal" class="avatar"></div>
            <span v-if="mode === 'photo'" class="user-name">{{userinfo.username}}</span>
            <span
                    @click="checkPersonal"
                    v-else-if="customize.avatarMode && userinfo.username"
                    class="user-name"
            >{{ avatarTitle() }}</span>
          </div>
        </div>
      </template>
      <div class="kiaf-person-center">
        <div v-show="personalShow" class="personal-center">
          <div class="triangle"><span></span></div>
          <div class="personal-title">
            <div class="buddha"></div>
            <kc-tooltip
              :content="userinfo.username"
              placement="bottom"
              effect="dark"
              :disabled="!isEllipsis(userinfo.username, 12)"
            >
              <div class="name">{{ userinfo.username }}</div>
            </kc-tooltip>
          </div>
          <div class="personal-content">
            <span class="icons">
              <kc-tooltip
                content="换肤"
                placement="bottom"
                effect="light"
                v-if="!customize.hideTheme"
              >
                <span @click.stop="updateHomePage('theme')">
                  <i class="kedaIconfont KD-huanfu"></i>
                </span>
              </kc-tooltip>
              <kc-tooltip
                content="下载"
                placement="bottom"
                effect="light"
                v-if="!customize.hideDownload"
              >
                <span @click.stop="lookDownload">
                  <i class="kedaIconfont KD-xiazaixiao"></i>
                </span>
              </kc-tooltip>
              <kc-tooltip
                content="设置"
                placement="bottom"
                effect="light"
                v-if="!customize.hideSetting"
              >
                <span @click.stop="updateHomePage('setting')">
                  <i class="kedaIconfont KD-shezhixiao"></i>
                </span>
              </kc-tooltip>
              <slot name="personCenterIconBox"></slot>
              <kc-tooltip
                :content="logoutIconTips"
                placement="bottom"
                effect="light"
                v-if="!customize.hideLogout"
              >
                <span @click.stop="logOut()" class="kiaf-logout-icon">
                  <i class="kedaIconfont KD-tuichuxiao"></i>
                </span>
              </kc-tooltip>
            </span>
            <p :title="userinfo.name" v-if="customize.showUserName === true">
              <span>用户姓名</span>{{ userinfo.name }}
            </p>
            <p :title="userinfo.deptName">
              <span>用户单位</span>{{ userinfo.deptName }}
            </p>
            <p v-if="customize.showUserRole === true">
              <span>用户角色</span>{{ getUserRole(0) }}
            </p>
            <p
              v-if="customize.showUserRole === true && getUserRole(1)"
              class="p-inline"
            >
              {{ getUserRole(1) }}
            </p>
            <p
              v-if="customize.showUserRole === true && getUserRole(2)"
              class="p-inline"
            >
              <kc-tooltip placement="bottom" effect="light">
                <div slot="content" v-html="getUserRole(-1)"></div>
                <span>更多>></span>
              </kc-tooltip>
            </p>
            <p
              :title="localAddr"
              v-if="
                customize.showPersonalLog === true && !customize.hideLocalAddr
              "
              @click.stop="updateHomePage('log')"
            >
              <span>登录地址</span>{{ localAddr }}
            </p>
            <p :title="localAddr" v-else-if="!customize.hideLocalAddr">
              <span>登录地址</span>{{ localAddr }}
            </p>
            <p><span>当前时间</span>{{ currentdate }}</p>
            <slot name="personCenterInfo"></slot>
            <p v-if="outOfDateTime">
              <span>过期时间</span>{{ outOfDateTime }}天后
            </p>
          </div>
        </div>
        <div v-show="downloadShow" class="download-center" @click.stop>
          <h3>
            下载
            <i
              @click.stop="closeDownload"
              class="kedaIconfont KD-guanbixiao"
            ></i>
          </h3>
          <p v-show="!downloadList.length">暂无下载任务！</p>
          <section class="m-scroll">
            <div
              class="item"
              v-for="(item, index) in downloadList"
              :key="index"
            >
              <kc-tooltip
                :content="item.name"
                placement="top"
                effect="light"
                :disabled="!isEllipsis(item.name, 30)"
                v-if="item.fileType == 'media'"
              >
                <p class="nowrap">{{ item.name }}</p>
              </kc-tooltip>
              <kc-tooltip
                :content="item.downloadType"
                placement="top"
                effect="light"
                :disabled="!isEllipsis(item.downloadType, 30)"
                v-else
              >
                <p class="nowrap">{{ item.downloadType }}</p>
              </kc-tooltip>
              <kc-progress
                :text-inside="true"
                :stroke-width="7"
                :show-text="false"
                :percentage="
                  item.status == 'Y'
                    ? 100
                    : (item.percentage >= 100 ? 100 : item.percentage) * 1
                "
              ></kc-progress>
              <p v-if="item.fileType == 'media'">
                {{ item.percentage }}%
                <span>
                  {{ item.statusDesc || (item.status == 'Y' ? '完成' : '下载中') }}
                  <i
                    class="kc-icon-delete download-delete"
                    @click="deleteMediaDownloadList(item)"
                  ></i>
                </span>
              </p>
              <p v-else>
                {{ item.beginTime }}
                <span>
                  {{ item.statusDesc || (item.status == 'Y' ? '完成' : '下载中') }}
                  <i
                    class="kc-icon-delete download-delete"
                    v-if="item.id"
                    @click="deleteDownloadList(item)"
                  ></i
                ></span>
              </p>
            </div>
          </section>
        </div>
      </div>
    </kc-popover>
    <kc-modal
      width="25rem"
      v-if="sessionWarningDialg"
      title="会话安全提醒"
      :visible.sync="sessionWarningDialg"
      v-model="sessionWarningDialg"
      :fullscreen-bg="true"
      append-to-body
      @beforeClose="sessionWarningDialg = false"
      class="business-homepage"
    >
      <span>{{ sessionWarningTips }}</span>
      <span slot="footer" class="dialog-footer">
        <kc-button @click="keepSessionActive">继续使用</kc-button>
        <kc-button type="primary" @click="logOutAction">立刻退出</kc-button>
      </span>
    </kc-modal>
  </div>
</template>
<script>
  import mixins from './mixins';
  import useDwonload from './useDownload';
  export default {
    name: 'KiafPersonCenter',
    mixins: [mixins],
    setup(props) {
      return {
        ...useDwonload(props)
      };
    }
  };
</script>
<style scoped>
.kiaf-person-center-wrapper {
  padding: 0px;
  margin: 0px;
}
.nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="scss">
  @import "index.scss";
</style>
